"use client";

import { useId, useState } from "react";

interface ChartPdfDownloadButtonProps {
  chartTitle?: string;
  isHindi?: boolean;
  className?: string;
}

export default function ChartPdfDownloadButton({
  chartTitle = "Janam Kundali Summary",
  isHindi = false,
  className = "",
}: ChartPdfDownloadButtonProps) {
  const [downloading, setDownloading] = useState(false);
  const [printFailed, setPrintFailed] = useState(false);
  const hintId = useId();

  const handlePrintDownload = () => {
    setDownloading(true);
    setPrintFailed(false);
    try {
      window.print();
    } catch {
      setPrintFailed(true);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div data-kundali-print-control>
      <button
        type="button"
        onClick={handlePrintDownload}
        disabled={downloading}
        className={`inline-flex items-center gap-2 rounded-xl border border-border-default bg-surface-raised px-4 py-2 text-body-small font-bold text-text-primary hover:bg-surface-warm transition-all shadow-xs disabled:opacity-50 ${className}`}
        aria-describedby={hintId}
        aria-label={
          isHindi ? "कुंडली प्रिंट करें या PDF में सेव करें" : `Print or save ${chartTitle} as PDF`
        }
      >
        <span>📄</span>
        <span>
          {downloading
            ? isHindi
              ? "तैयार किया जा रहा है..."
              : "Opening print dialog..."
            : isHindi
              ? "प्रिंट करें या PDF में सेव करें"
              : "Print or save as PDF"}
        </span>
      </button>
      <p id={hintId} className="mt-2 text-caption text-text-secondary">
        {isHindi
          ? "PDF सेव करने के लिए प्रिंट विंडो में ‘Save as PDF’ चुनें।"
          : "Choose ‘Save as PDF’ in your browser’s print dialog to save a copy."}
      </p>
      {printFailed && (
        <p role="alert" className="mt-2 text-body-small text-error">
          {isHindi
            ? "प्रिंट विंडो नहीं खुल सकी। फिर से कोशिश करें या ब्राउज़र के प्रिंट विकल्प का उपयोग करें।"
            : "The print dialog could not open. Please try again or use your browser’s Print option."}
        </p>
      )}
    </div>
  );
}
